// extracted by mini-css-extract-plugin
export default {"header":"_36VuzQ3I","heading":"_3KCAH-mh","bestMatchLink":"_12IcH_a_"};